import { Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { IGenericApiClient } from "../../../ApiClients/Catalogues/GenericApiClient";
import { CatalogueEntry } from "../CatalogueEntry";
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"
import InternalRating from "../../../Models/Catalogue/Investments/InternalRating";
import { AppService, DomainTypes } from "../../../DomainTypes";
import DataCache from "../../../Services/DataCache";
import { Catalogue } from "@singularsystems/neo-react-services";

export default class InternalRatingCatalogueEntry extends CatalogueEntry<InternalRating> {

    private investmentsApiClient = AppService.get(DomainTypes.ApiClients.CatalogueInvestment);

    constructor() {
        super("Internal Ratings", InternalRating);
    }

    public get editRole() {
        return CatalogueRoles.InternalRatings.Edit;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.internalRatings;
    }

    public getSaveEndpoint(apiClient: IGenericApiClient) {
        return this.investmentsApiClient.saveInternalRatings;
    }

    public renderRow(item: InternalRating, meta: Model.TransformMetaType<InternalRating>) {
        return (
            <NeoGrid.Row>
                <NeoGrid.Column bind={meta.internalRatingName} />
                <Catalogue.ButtonColumn />
            </NeoGrid.Row>
        )
    }
}